import { hasDuplicate, shuffleItems } from 'utils/array';

export const Penis = [
  {
    imgSrc: require('../images/pixidixi/Devildick.PNG'),
    title: 'Devildick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938703967914295297',
  },
  {
    imgSrc: require('../images/pixidixi/Dickangel.PNG'),
    title: 'Dickangel',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938702868402667521',
  },
  {
    imgSrc: require('../images/pixidixi/Discodick.PNG'),
    title: 'Discodick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938701768891039745',
  },
  {
    imgSrc: require('../images/pixidixi/Heisenberg.png'),
    title: 'Heisendick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938706166937550849',
  },
  {
    imgSrc: require('../images/pixidixi/Legionnaire.png'),
    title: 'Legiondick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938707266449178625',
  },
  {
    imgSrc: require('../images/pixidixi/Superdick.png'),
    title: 'Superdick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938705067425923073',
  },
  {
    imgSrc: require('../images/pixidixi/Dickstar.PNG'),
    title: 'Dickstar',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938708365960806401',
  },
  {
    imgSrc: require('../images/pixidixi/Presidentialdick.png'),
    title: 'Presidentialdick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938709465472434177',
  },
  {
    imgSrc: require('../images/pixidixi/Rastadick.png'),
    title: 'Rastadick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938710564984061953',
  },
  {
    imgSrc: require('../images/pixidixi/Icedick.png'),
    title: 'Icedick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938711664495689729',
  },
  {
    imgSrc: require('../images/pixidixi/Batdick.png'),
    title: 'Batdick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938712764007317505',
  },
  {
    imgSrc: require('../images/pixidixi/Dulk.PNG'),
    title: 'Dulk',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938722659611967489',
  },
  {
    imgSrc: require('../images/pixidixi/Hippydick.PNG'),
    title: 'Hippydick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938716062542200833',
  },
  {
    imgSrc: require('../images/pixidixi/Naplesdick.PNG'),
    title: 'Naplesdick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938721560100339713',
  },
  {
    imgSrc: require('../images/pixidixi/PenisJackson.PNG'),
    title: 'Penis Jackson',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938723759123595265',
  },
  {
    imgSrc: require('../images/pixidixi/Portaldick.PNG'),
    title: 'Portaldick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938713863518945281',
  },
  {
    imgSrc: require('../images/pixidixi/PridedickMan.png'),
    title: 'Pridedick Man',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938719361077084161',
  },
  {
    imgSrc: require('../images/pixidixi/PridedickWoman.png'),
    title: 'Pridedick Woman',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938718261565456385',
  },
  {
    imgSrc: require('../images/pixidixi/Prisondick.PNG'),
    title: 'Prisondick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938717162053828609',
  },
  {
    imgSrc: require('../images/pixidixi/Spiderdick.PNG'),
    title: 'Spiderdick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938714963030573057',
  },
  {
    imgSrc: require('../images/pixidixi/Tribaldick.png'),
    title: 'Tribaldick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938720460588711937',
  },
  {
    imgSrc: require('../images/pixidixi/DickGame.PNG'),
    title: 'Dick Game',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938724858635223041',
  },
  {
    imgSrc: require('../images/pixidixi/TennisDick.PNG'),
    title: 'Tennis Dick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938725958146850817',
  },
  {
    imgSrc: require('../images/pixidixi/Moondick.PNG'),
    title: 'Moondick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938727057658478593',
  },
  {
    imgSrc: require('../images/pixidixi/Militarydick.PNG'),
    title: 'Militarydick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938728157170106369',
  },
  {
    imgSrc: require('../images/pixidixi/Dickmon.PNG'),
    title: 'Dickmon',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938729256681734145',
  },
  {
    imgSrc: require('../images/pixidixi/Dickcraft.PNG'),
    title: 'Dickcraft',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938730356193361921',
  },
  {
    imgSrc: require('../images/pixidixi/Constructiondick.PNG'),
    title: 'Constructiondick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938731455704989697',
  },
  {
    imgSrc: require('../images/pixidixi/Superdickayan.PNG'),
    title: 'Superdickayan',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938732555216617473',
  },
  {
    imgSrc: require('../images/pixidixi/CatholicDick.PNG'),
    title: 'Catholic Dick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938733654728245249',
  },
  {
    imgSrc: require('../images/pixidixi/Dhrek.PNG'),
    title: 'Dhrek',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938734754239873025',
  },
  {
    imgSrc: require('../images/pixidixi/RobinDick.PNG'),
    title: 'Robin Dick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938735853751500801',
  },
  {
    imgSrc: require('../images/pixidixi/The3Dicketeers.PNG'),
    title: 'The 3 Dicketeers',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938736953263128577',
  },
  {
    imgSrc: require('../images/pixidixi/DarthDick.png'),
    title: 'Darth Dick',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938738052774756353',
  },
  {
    imgSrc: require('../images/pixidixi/DickTrooper.PNG'),
    title: 'Dick Trooper',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938739152286384129',
  },
  {
    imgSrc: require('../images/pixidixi/DickCrucified.png'),
    title: 'Dick Crucified',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938740251798011905',
  },
  {
    imgSrc: require('../images/pixidixi/Dhor.PNG'),
    title: 'Dhor',
    description: '',
    link: 'https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/12329634842013599571979703586833654291870594755673280300158938741351309639681',
  },
];

console.log(`The length of penis collection is: ${Penis.length}`);
console.log(`There are ${hasDuplicate(Penis.map((i) => i.link)) ? '' : 'not'} link repetitions`);
console.log(`There are ${hasDuplicate(Penis.map((i) => i.imgSrc)) ? '' : 'not'} img src repetitions`);
console.log(`There are ${hasDuplicate(Penis.map((i) => i.title)) ? '' : 'not'} title repetitions`);

export const Items = shuffleItems([...Penis]);
